<template>
  <li @click="goToDetail(project)">
    <a
      href="#"
      class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
    >
      <div class="px-4 py-4 flex items-center sm:px-6">
        <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <div class="text-sm leading-5 font-medium text-indigo-600 truncate">
              {{ project.title }}
            </div>
            <div class="mt-2 flex">
              <div class="flex items-center text-sm leading-5 text-gray-500">
                <svg
                  class="flex-shrink-0 mr-2 h-5 w-5 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>
                  Sortie le
                  <time>{{ project.date | date_dmy }}</time>
                </span>
                <svg
                  class="flex-shrink-0 mr-2 ml-4 h-5 w-5 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span>
                  {{ project.clips_count }}
                  {{ project.clips_count > 0 ? "clips" : "clip" }}
                </span>
              </div>
            </div>
          </div>
          <div class="mt-4 flex-shrink-0 sm:mt-0">
            <div class="flex overflow-hidden">
              <img
                v-for="user in project.users"
                :key="user.id"
                class="inline-block h-6 w-6 rounded-full text-white shadow-solid"
                :src="user.avatar"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="ml-5 flex-shrink-0">
          <svg
            class="h-5 w-5 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    methods: {
        goToDetail(project) {
            this.$router.push({
                name: "project-show",
                params: { id: project.public_id }
            });
        }
    }
};
</script>